import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';

interface UploadedFileInformationProps {
  fileName?: string;
  fileSize?: number;
  totalRecords?: number;
  hideFileSize?: boolean;
}

const UploadedFileInformation = ({
  fileName,
  fileSize,
  totalRecords,
  hideFileSize = false,
}: UploadedFileInformationProps) => {
  const { messages } = useTypedIntl();
  return (
    <div className="UploadedFileInformation">
      <div className="flex mb-2">
        <div>{messages['bulkUpdate.modal.fileName']}:</div>
        <div className="ml-2">{fileName || '-'}</div>
      </div>
      {!hideFileSize && (
        <div className="flex mb-2">
          <div>{messages['bulkUpdate.modal.fileSize']}:</div>
          <div className="ml-2">
            {fileSize ? `${Math.round(fileSize / 1024)} KB` : '-'}
          </div>
        </div>
      )}
      <div className="flex mb-2">
        <div>{messages['bulkUpdate.modal.totalRecords']}:</div>
        <div className="ml-2">{totalRecords ?? '-'}</div>
      </div>
    </div>
  );
};

export default UploadedFileInformation;
